import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/Updates/TenantSelector.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/workspace/node_modules/next/dist/client/app-dir/link.js");
